<template>
  <div class='worker small-text'>
    <div v-if='language === "nl"'
         class='italic'>{{item.title}}</div>
    <div v-if='language === "en"'
         class='italic'>{{item.title_en}}</div>
    <div class='secondary-color strong'>{{item.name}}</div>
    <div>
      <a :href='item["email_address"]'>{{item['email_address']}}</a>
    </div>
    <div>{{item['phone_number']}}</div>
  </div>
</template>

<script>
export default {
  name: 'dsTeamItem',
  props: ['language', 'item']
}
</script>

<style lang='scss' scoped>
@import '../styles/helpers/_mixins.scss';
@import '../styles/responsive/_manager.scss';
@import '../styles/_variables.scss';
@import '../styles/_space.scss';
@import '../styles/_color.scss';
@import '../styles/_typography.scss';

.worker {
  line-height: 2 * $baseline;
  margin-bottom: 2 * $baseline;
  span {
    position: relative;
    top: -4px;
  }
}
</style>



// WEBPACK FOOTER //
// dsTeamItem.vue?48cdca14